<template>
  <div class="page-content">
    <div class="page-title">Executive Board</div>
    <div class="text">
      The Executive Board ensures the overall management of WFUCA. The functions
      and responsibilities of the Executive Board are derived primarily from the
      Constitution and General Rules laid down by the World Congress. The
      Executive Board consists of the members elected by the World Congress
      (including the President, five Vice-Presidents, five members and a
      Treasurer) and the ex-officio members.
    </div>
    <div class="people-view">
      <el-row :gutter="20" class="people-row">
        <el-col :span="12">
          <div class="title">The President</div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Bolat AKCHULAKOV</div>
          <div class="country">Country: Kazakhstan</div>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="people-row">
        <el-col :span="12">
          <div class="title">
            Vice-Presidents(Europe and North America region)
          </div>
          <img src="@/assets/images/gov/people02.png" />
          <div class="name">Ms. Daniela POPESCU</div>
          <div class="country">Country：Romania</div>
        </el-col>
        <el-col :span="12">
          <div class="title">
            Vice-Presidents(Latin America and the region Cribbean)
          </div>
          <img src="@/assets/images/gov/people02.png" />
          <div class="name">Ms. Katannia PLUMMER-MITCHELL</div>
          <div class="country">Country：Jamaica</div>
        </el-col>
        <el-col :span="12">
          <div class="title">Vice-Presidents (Asia and Pacific region)</div>
          <img src="@/assets/images/gov/people02.png" />
          <div class="name">Ms. Young Shik KIM</div>
          <div class="country">Country：Korea</div>
        </el-col>
        <el-col :span="12">
          <div class="title">Vice-Presidents (Africa region)</div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Ahogbédji Gabin ALLOGNON</div>
          <div class="country">Country：Benin</div>
        </el-col>
        <el-col :span="12">
          <div class="title">Vice-Presidents (Arab Sates region)</div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Mokhtar FARHAT</div>
          <div class="country">Country：Tunisia</div>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="people-row">
        <el-col :span="12">
          <div class="title">Treasurer</div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Dzmitry SUBTSLNY</div>
          <div class="country">Country：Belarus</div>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="people-row">
        <el-col :span="12">
          <div class="title">
            Member of EB (Europe and North America region)
          </div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Ioannis MARONITIS</div>
          <div class="country">Country：Greece</div>
        </el-col>
        <el-col :span="12">
          <div class="title">Member of EB (Asia and Pacific region)</div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Nazir SHARIFI</div>
          <div class="country">Country：Tajikistan</div>
        </el-col>
        <el-col :span="12">
          <div class="title">Member of EB (Africa region)</div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Augustin BOUDA</div>
          <div class="country">Country：Burkina-Faso</div>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="people-row">
        <el-col :span="12">
          <div class="title">Ex-Officio Member-China</div>
          <img src="@/assets/images/gov/people02.png" />
          <div class="name">Ms. Aijun YUAN</div>
          <div class="country">Country：China</div>
        </el-col>
        <el-col :span="12">
          <div class="title">Ex-Officio Member-Italy</div>
          <img src="@/assets/images/gov/people02.png" />
          <div class="name">Ms. Maria Paola AZZARIO</div>
          <div class="country">Country：Italy</div>
        </el-col>
        <el-col :span="12">
          <div class="title">Ex-Officio Member-Japan</div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Yuji SUZUKI</div>
          <div class="country">Country：Japan</div>
        </el-col>
        <el-col :span="12">
          <div class="title">Ex-Officio Member-Vietnam</div>
          <img src="@/assets/images/gov/people01.png" />
          <div class="name">Mr. Manh TRAN VAN</div>
          <div class="country">Country：Vietnam</div>
        </el-col>
      </el-row>
    </div>
    <!--  -------------------------------------------------------------------------    -->
    <div class="page-title">
      The session of Executive Board since the last World Congress
    </div>
    <div class="sub-view">
      <div class="sub-item">
        <div class="sub-title">
          The Extraordinary Session
          <div class="year">Aug 2019</div>
          <div class="country">Paris, France</div>
        </div>
        <div class="sub-doc">
          <div class="label">Documents：</div>
          <div class="doc-view">
            <a href="#" class="doc-item">Report_En</a>
            <a href="#" class="doc-item">Report_Fr</a>
          </div>
        </div>
      </div>

      <div class="sub-item">
        <div class="sub-title">
          The 39th Ordinary Session
          <div class="year">Jun 2018</div>
          <div class="country">Chalkida, Greece</div>
        </div>
        <div class="sub-doc">
          <div class="label">Documents：</div>
          <div class="doc-view">
            <a href="#" class="doc-item">Report_En</a>
            <a href="#" class="doc-item">Report_Fr</a>
          </div>
        </div>
      </div>
      <div class="sub-item">
        <div class="sub-title">
          The 38th Ordinary Session
          <div class="year">Jul 2017</div>
          <div class="country">Senda, Japan</div>
        </div>
        <div class="sub-doc">
          <div class="label">Documents：</div>
          <div class="doc-view">
            <a href="#" class="doc-item">Report_En</a>
          </div>
        </div>
      </div>
      <div class="sub-item">
        <div class="sub-title">
          The Extraordinary Session
          <div class="year">Jun 2016</div>
          <div class="country">Shanghai, China</div>
        </div>
        <div class="sub-doc">
          <div class="label">Documents：</div>
          <div class="doc-view">
            <a href="#" class="doc-item">Report_En</a>
            <a href="#" class="doc-item">Report_Fr</a>
          </div>
        </div>
      </div>
      <div class="sub-item">
        <div class="sub-title">
          The Extraordinary Session
          <div class="year">Oct 2015</div>
          <div class="country">Bucharest, Romania</div>
        </div>
      </div>
      <div class="sub-item">
        <div class="sub-title">
          The 37th Ordinary Session
          <div class="year">Jul 2015</div>
          <div class="country">Beijing, China</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.mobile {
  #pane-Executive {
    .page-content .people-view .el-col-12{
      margin-bottom: 20px;
      img {
        width: 100%;
      }
      .title {
        font-size: 18px !important;
        line-height: 24px !important;
        min-height: 80px !important;
      }
      .name {
        font-size: 16px !important;
        line-height: 20px !important;
        min-height: 40px !important;
      }
    }
  }
}
.page-content {
  width: 100%;
  .people-view {
    .people-row {
    }
    .el-col-12 {
      margin-bottom: fh(60vh, pc);
    }
    .title {
      font-size: fh(36vh, pc);
      font-weight: bold;
      color: #333;
      margin-bottom: fh(15vh, pc);
      min-height: fh(80vh, pc);
    }
    img {
      width: fw(182vw, pc);
      margin-top: fh(15vh, pc);
      margin-bottom: fh(20vh, pc);
    }
    .name {
      font-size: fh(24vh, pc);
      line-height: fh(36vh, pc);
      font-weight: bold;
      color: #333;
      margin-bottom: fh(15vh, pc);
    }
    .country {
      font-size: fh(18vh, pc);
      line-height: fh(36vh, pc);
      color: #2a2a2a;
    }
  }
  .sub-view {
    width: 100%;
    .sub-item {
      margin-bottom: fh(20vh, pc);
      color: #333333;
      padding: fh(40vh, pc) fw(40vw, pc);
      background-color: #f7f7f7;
      border-radius: 8px;
      .sub-title {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: fh(32vh, pc);
        line-height: fh(38vh, pc);
        font-weight: bold;
        margin-bottom: fh(40vh, pc);
        .year {
          margin-left: fw(60vw, pc);
          font-size: fh(24vh, pc);
          line-height: fh(30vh, pc);
          font-weight: normal;
        }
        .country {
          margin-left: fw(20vw, pc);
          font-size: fh(24vh, pc);
          line-height: fh(30vh, pc);
          font-weight: normal;
        }
      }
      .sub-doc {
        width: 100%;
        display: flex;
        font-size: fh(24vh, pc);
        line-height: fh(30vh, pc);
        .label {
          color: #999;
          margin-right: fw(20vw, pc);
        }
        .doc-view {
          .doc-item {
            display: block;
            color: #333;
            text-decoration: underline;
            margin-bottom: fh(24vh, pc);
            &:nth-last-child(1) {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  .text {
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
    margin-bottom: fh(60vh, pc);
  }
}
</style>
